module.exports = __webpack_public_path__ + "daf4264ea65638d7d393163a6f4dfe50.pdf";